unit libnfc;

interface

{$mode objfpc}
{$modeswitch externalclass}

uses
  Classes, js, web, libserviceworkers;

type
  TJSAbortSignal = class external name 'AbortSignal' (TJSEventTarget)

  end;

  TJSAbortController = class external name 'AbortController' (TJSObject)
  private
    FSignal: TJSAbortSignal; external name 'signal';
  public
    procedure abort;
    property signal: TJSAbortSignal read FSignal;
  end;

  TJSNDEFRecordInit = class external name 'NDEFRecordInit' (TJSObject)
  private
    FRecordType: string; external name 'recordType';
    FMediaType: string; external name 'mediaType';
    FID: string; external name 'id';
    FEncoding: string; external name 'encoding';
    FLang: string; external name 'lang';
    FData: JSValue; external name 'data';
  public
    property recordType: string read FRecordType write FRecordType;
    property mediaType: string read FMediaType write FMediaType;
    property id: string read FID write FID;
    property encoding: string read FEncoding write FEncoding;
    property lang: string read FLang write FLang;
    property data: JSValue read FData write FData;
  end;

  TJSNDEFRecord = class external name 'NDEFRecord' (TJSObject)
  private
    FRecordType: string; external name 'recordType';
    FMediaType: string; external name 'mediaType';
    FID: string; external name 'id';
    FEncoding: string; external name 'encoding';
    FLang: string; external name 'lang';
    FData: TJSArrayBuffer; external name 'data';
  public
    constructor new(options: TJSObject);
    property recordType: string read FRecordType write FRecordType;
    property mediaType: string read FMediaType write FMediaType;
    property id: string read FID write FID;
    property encoding: string read FEncoding write FEncoding;
    property lang: string read FLang write FLang;
    property data: TJSArrayBuffer read FData write FData;
  end;

  TJSNDEFReaderWriteOption = class external name 'Object' (TJSObject)
    overwrite: Boolean;
    signal: TJSAbortSignal;
  end;

  TJSNDEFRecordArray = array of TJSNDEFRecord;

  TJSNDEFMessageInit = class external name 'Object' (TJSObject)
    records: TJSArray;
  end;

  TJSNDEFMessage = class external name 'NDEFMessage' (TJSObject)
    records: array of TJSNDEFRecord;
  end;

  TJSNDEFReadingEvent = class external name 'NDEFReadingEvent' (TJSEvent)
  private
    FSerialNumber: string; external name 'serialNumber';
    FMessage: TJSNDEFMessage; external name 'message';
  public
    property serialNumber: string read FSerialNumber;
    property &message: TJSNDEFMessage read FMessage;
  end;

  TJSNDEFReader = class external name 'NDEFReader' (TJSEventTarget)
  public
    //procedure addEventListener(aname : string; aListener : TJSEventHandler); overload;
    procedure addEventListener(aname : string; aListener : TJSEventHandler; aOption: TJSObject); overload;
    function scan: TJSPromise; overload;
    function scan(aOptions: TJSObject): TJSPromise; overload;
    function write(aMessage: string): TJSPromise; overload;
    function write(aMessage: TJSArrayBuffer): TJSPromise; overload;
    function write(aMessage: TJSDataView): TJSPromise; overload;
    function write(aMessage: TJSNDEFMessageInit): TJSPromise; overload;
    function write(aMessage: TJSTypedArray): TJSPromise; overload;
    function write(aMessage: string; aOption: TJSNDEFReaderWriteOption): TJSPromise; overload;
    function write(aMessage: TJSArrayBuffer; aOption: TJSNDEFReaderWriteOption): TJSPromise; overload;
    function write(aMessage: TJSDataView; aOption: TJSNDEFReaderWriteOption): TJSPromise; overload;
    function write(aMessage: TJSNDEFMessageInit; aOption: TJSNDEFReaderWriteOption): TJSPromise; overload;
    function write(aMessage: TJSTypedArray; aOption: TJSNDEFReaderWriteOption): TJSPromise; overload;
  end;

implementation

end.
